import { FC, useMemo, useContext, PropsWithChildren } from 'react';
import useParticipants from '@/hooks/data/useParticipants';
import ParticipantsContext from '@/contexts/data/ParticipantsContext';
import { QueryParticipantsResponse } from '@/api/dtos';
import IsLoading from '@/components/layouts/IsLoading';
import TrialContext from '@/contexts/data/TrialContext';
import InstitutionContext from '@/contexts/data/InstitutionContext';


export interface IParticipantsProviderProps {
    initial?: QueryParticipantsResponse;
}

export const ParticipantsProvider: FC<PropsWithChildren<IParticipantsProviderProps>> = ({ initial, children }) => {
    const { data: trial } = useContext(TrialContext);
    const { data: institution } = useContext(InstitutionContext);
    const participants = useParticipants(trial ? { trialId: trial.id, institutionId: institution?.id } : undefined, { revalidateOnFocus: false, fallbackData: initial});

    return (

        <ParticipantsContext.Provider value={participants}>
            <IsLoading name="participants" loading={participants.loading} validating={participants.validating}/>
            {children}
        </ParticipantsContext.Provider>
    );
}

export default ParticipantsProvider;
